import React, { useMemo } from "react";
import RecentSummary from "../recent-summary/RecentSummary";
import RecentItem from "../recent-summary/parts/RecentItem";
import iconPdf from "../../assets/images/dummy/icon-pdf.png";
import { IconCalendar1, IconBook1 } from "../../icons/Icon";

const title = "Promociones actualizadas";
const badgeColor = "#FFD88D";

const RecentCampaigns = ({ loading, faldones = [] }) => {
  const orderedFaldones = useMemo(() => {
    if (!Array.isArray(faldones)) return [];
    return [...faldones]
      .filter(Boolean)
      .sort(
        (a, b) =>
          new Date(b?.FECHA_HORA_CARGA || 0).getTime() -
          new Date(a?.FECHA_HORA_CARGA || 0).getTime()
      );
  }, [faldones]);

  const formatDate = (value, withTime = false) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";
    const options = withTime
      ? {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }
      : {
          day: "2-digit",
          month: "short",
          year: "numeric",
        };
    return new Intl.DateTimeFormat("es-CL", { ...options, timeZone: "UTC" }).format(date);
  };

  const formatRange = (start, end) => {
    if (!start && !end) return "Sin vigencia";
    if (start && !end) return `Desde ${formatDate(start)}`;
    if (!start && end) return `Hasta ${formatDate(end)}`;
    return `${formatDate(start)} - ${formatDate(end)}`;
  };

  return (
    <RecentSummary
      title={title}
      badgeColor={badgeColor}
      noData={!orderedFaldones.length}
      loading={loading}
    >
      {orderedFaldones.map((item, idx) => {
        const key = [item?.CAMPANA, item?.FALDON_XLSX, item?.FECHA_HORA_CARGA, idx]
          .filter(Boolean)
          .join("|");
        return (
        <RecentItem
          key={key}
          icon={IconBook1}
          primaryInfo={item?.CAMPANA || "Campaña sin nombre"}
          secondaryInfo={
            <>
              <div className="d-flex align-items-center gap-2">
                <IconCalendar1 color="#748A9D" />
                <span>Actualizado {formatDate(item?.FECHA_HORA_CARGA, true)}</span>
              </div>
              {/* <div className="text-muted small">
                Vigencia {formatRange(item?.FECHA_VIGENCIA_DESDE, item?.FECHA_VIGENCIA_HASTA)}
              </div> */}
            </>
          }
          hideControl
        />
      )})}
    </RecentSummary>
  );
};

export default RecentCampaigns;

